<template>
  <div class="mainContent">
    <h2 class="card-title">{{gene}}</h2>

    <div class="row">
      <div class="col-sm-12">
        <h4 class="round">UMAP <span style="font-size: 13px; padding-top: 4px;">(with considered parameter set)</span></h4>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <h5 class="card-title">Optimal parameters <span style="font-weight: 300">(from both strains)</span></h5>
        <div class="panel panel-default">
          <img :src="getUmapPADOptSvg(itemId)"/>
        </div>
      </div>
      <div class="col-sm-4">
        <h5 class="card-title">Morphogenesis Strain parameters only</h5>
        <div class="panel panel-default">
          <img :src="getUmapPADMsSvg(itemId)"/>
        </div>
      </div>
      <div class="col-sm-4">
        <h5 class="card-title">Germ Layer Strain parameters only</h5>
        <div class="panel panel-default">
          <img :src="getUmapPADGlsSvg(itemId)"/>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <h4 class="round">Best Phenotypic Matches <span style="font-size: 13px; padding-top: 4px;">(with considered parameter set)</span></h4>
      </div>
    </div>

<!--    Fetch the csv file and load it in the below -->
    <fetch-p-a-d-csv :id="itemId">
      <template v-slot="{response, loading}">
        <div v-if="loading">Loading...</div>

        <div v-else class="row">
          <div class="col-sm-4">
            <h5 class="card-title">Optimal parameters <span style="font-weight: 300">(from both strains)</span></h5>
            <div class="panel panel-default">
              <table class="pad table table-striped table-hover table-responsive">
                <thead>
                  <tr class="active">
                    <th>hit</th>
                    <th>PAD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in getOptParamMatches(response)" v-bind:key="'opt-' + index">
                    <th scope="row" class="gene-name"><a :href="'/embdView/' + item.gene">{{item.gene}}</a></th>
                    <td>{{item.pad}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-sm-4">
            <h5 class="card-title">Morphogenesis Strain parameters only</h5>
            <div class="panel panel-default">
              <table class="pad table table-striped table-hover table-responsive">
                <thead>
                <tr class="active">
                  <th>hit</th>
                  <th>PAD</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in getMSParamMatches(response)" v-bind:key="'ms-' + index">
                  <th scope="row" class="gene-name"><a :href="'/embdView/' + item.gene">{{item.gene}}</a></th>
                  <td>{{item.pad}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-sm-4">
            <h5 class="card-title">Germ Layer Strain parameters only</h5>
            <div class="panel panel-default">
              <table class="pad table table-striped table-hover table-responsive">
                <thead>
                <tr class="active">
                  <th>hit</th>
                  <th>PAD</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in getGLSParamMatches(response)" v-bind:key="'gls-' + index">
                  <th scope="row" class="gene-name"><a :href="'/embdView/' + item.gene">{{item.gene}}</a></th>
                  <td>{{item.pad}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </fetch-p-a-d-csv>
    <h4>To access best matches for ALL query genes with optimal, Germ-Layer strain specific, or Morphogenesis strain specific parameters, click <a href="/csv/all_best_matches_05192022.xlsx">here</a>.</h4>
  </div>
</template>

<script>
import FetchPADCsv from "./FetchPADCsv";

export default {
  name: "UMAPView.vue",
  components: {
    FetchPADCsv
  },
  data() {
    return {
      gene: this.$route.params.gene,
      itemId: this.$route.params.id,
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    zeroPad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    getUmapPADOptSvg(num) {
      const vm = this
      let id = vm.zeroPad(num, 4)
      return `/svg/EMBD${id}_UMAP_PAD_optParams.svg`
    },
    getUmapPADMsSvg(num) {
      const vm = this
      let id = vm.zeroPad(num, 4)
      return `/svg/EMBD${id}_UMAP_PAD_MSparams.svg`
    },
    getUmapPADGlsSvg(num) {
      const vm = this
      let id = vm.zeroPad(num, 4)
      return `/svg/EMBD${id}_UMAP_PAD_GLSparams.svg`
    },
    getOptParamMatches(data) {
      return data.map(function(d) {
        return {
          rank: d[0],
          embd: d[3],
          gene: d[4],
          pad: d[5].substring(0, 5)
        }
      })
    },
    getMSParamMatches(data) {
      return data.map(function(d) {
        return {
          rank: d[0],
          embd: d[9],
          gene: d[10],
          pad: d[11].substring(0, 5)
        }
      })
    },
    getGLSParamMatches(data) {
      return data.map(function(d) {
        return {
          rank: d[0],
          embd: d[6],
          gene: d[7],
          pad: d[8].substring(0, 5)
        }
      })
    },
  },
  async mounted() {
  },
}
</script>

<style>
@import url('~@/assets/bootstrap.css');
@import url('~@/assets/datatable.css');

table.pad tr { font-size: 13px; }

.mainContent {
  border-radius: 25px;
  border: 2px solid #dae3f3;
  padding: 20px;
  margin: 1.5rem;
}

.round {
  font-family: Calibri, Candara, Segoe, Segoe UI, Optima, Arial;
  border-radius: 7px;
  border: 1px solid #d9d9d9;
  background: #dae3f3;
  padding: 3px 7px 3px 7px;
  font-style: oblique;
  color: #203864;
  font-weight: bold;
}

p.strong {
  text-decoration: underline;
  font-style: oblique;
}

h2.card-title {
  margin-top: 0;
  color: #2f5597;
  font-style: oblique;
}

h5.card-title {
  color: #2f5597;
  font-size: 16px;
  font-style: oblique;
  font-weight: 900;
  text-decoration: underline;
}
</style>